(function () {
  if (window.customElements.get('pack-set')) {
    return;
  }

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0];
    var decimals = parts[1];
    var wholeWithDots = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var wholeWithCommas = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    if (!format) {
      return whole + ',' + decimals + '€';
    }

    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, wholeWithDots + ',' + decimals)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, wholeWithDots)
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, whole.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + decimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, wholeWithCommas)
      .replace(/\{\{\s*amount\s*\}\}/g, wholeWithCommas + '.' + decimals);
  }

  class PackSet extends HTMLElement {
    connectedCallback() {
      var dataEl = this.querySelector('[data-pack-data]');
      if (!dataEl) {
        return;
      }

      try {
        this.data = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      this.formId = this.dataset.formId;
      this.shellVariantId = Number(this.dataset.shellVariant);
      this.moneyFormat = this.getAttribute('money-format');
      this.errorEl = this.querySelector('[data-pack-error]');
      this.rows = Array.prototype.slice.call(this.querySelectorAll('[data-pack-member]'));

      this._onSubmit = this._handleSubmit.bind(this);
      this._onVariantChange = this._handleVariantChange.bind(this);
      this._onRerender = this._handleRerender.bind(this);

      document.addEventListener('submit', this._onSubmit, true);
      document.addEventListener('variant:change', this._onVariantChange);

      var form = this._form();
      if (form) {
        form.addEventListener('product:rerender', this._onRerender);
      }

      this.querySelectorAll('[data-pack-overlay]').forEach(function (overlay) {
        var image = overlay.querySelector('[data-pack-overlay-image]');
        var thumbs = Array.prototype.slice.call(overlay.querySelectorAll('[data-pack-overlay-thumb]'));
        thumbs.forEach(function (thumb) {
          thumb.addEventListener('click', function () {
            image.src = thumb.dataset.packOverlayThumb;
            thumbs.forEach(function (other) {
              other.classList.toggle('is-active', other === thumb);
            });
          });
        });
      });

      this._update();
    }

    disconnectedCallback() {
      document.removeEventListener('submit', this._onSubmit, true);
      document.removeEventListener('variant:change', this._onVariantChange);
    }

    _form() {
      return document.getElementById(this.formId);
    }

    _sizeTitle() {
      var shell = this.data.shellVariants.find(function (v) {
        return v.id === this.shellVariantId;
      }, this);
      return shell ? shell.title : null;
    }

    _memberVariant(member, sizeTitle) {
      if (member.singleVariant || member.variants.length === 1) {
        return member.variants[0] || null;
      }
      return member.variants.find(function (v) {
        return v.title === sizeTitle;
      }) || null;
    }

    _linesFor(sizeTitle) {
      return this.data.members.map(function (member) {
        return this._memberVariant(member, sizeTitle);
      }, this);
    }

    _sizeAvailable(sizeTitle) {
      return this._linesFor(sizeTitle).every(function (v) {
        return v && v.available;
      });
    }

    _handleVariantChange(event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) {
        return;
      }
      var id = Number(variant.id);
      var isShell = this.data.shellVariants.some(function (v) {
        return v.id === id;
      });
      if (!isShell) {
        return;
      }
      this.shellVariantId = id;
      this._update();
    }

    _handleRerender() {
      setTimeout(this._update.bind(this), 0);
    }

    _update() {
      var sizeTitle = this._sizeTitle();
      var lines = this._linesFor(sizeTitle);
      var discount = this.data.discount;
      var total = 0;
      var ready = lines.every(function (v) { return v && v.available; });

      lines.forEach(function (v, index) {
        var member = this.data.members[index];
        if (!v) {
          return;
        }
        total += v.price;
        var discounted = Math.round(v.price * (100 - discount) / 100);
        this.querySelectorAll('[data-pack-member="' + member.id + '"] [data-pack-member-price], [data-pack-overlay-member="' + member.id + '"][data-pack-member-price]').forEach(function (el) {
          el.textContent = formatMoney(discounted, this.moneyFormat);
        }, this);
        this.querySelectorAll('[data-pack-member="' + member.id + '"] [data-pack-member-compare], [data-pack-overlay-member="' + member.id + '"][data-pack-member-compare]').forEach(function (el) {
          el.textContent = formatMoney(v.price, this.moneyFormat);
        }, this);
      }, this);

      this._applyPrice(total, discount);
      this._applyAvailability();
      this._toggleSubmit(ready);
    }

    _applyPrice(total, discount) {
      var priceList = document.querySelector('.product-info__price .price-list');
      if (!priceList || !total) {
        return;
      }
      var discounted = Math.round(total * (100 - discount) / 100);
      var html = '<sale-price class="text-lg text-on-sale">' + formatMoney(discounted, this.moneyFormat) + '</sale-price>';
      if (discount > 0) {
        html += '<compare-at-price class="text-subdued line-through">' + formatMoney(total, this.moneyFormat) + '</compare-at-price>';
        html += '<span class="price-chip">-' + discount + '%</span>';
      }
      priceList.innerHTML = html;
    }

    _applyAvailability() {
      var form = this._form();
      var picker = document.querySelector('.product-info .variant-picker');
      if (!picker) {
        return;
      }
      var labels = Array.prototype.slice.call(picker.querySelectorAll('.block-swatch'));
      labels.forEach(function (label) {
        var title = label.textContent.trim();
        var available = this._sizeAvailable(title);
        label.classList.toggle('is-disabled', !available);
        var input = label.previousElementSibling;
        if (input && input.tagName === 'INPUT') {
          input.setAttribute('aria-disabled', available ? 'false' : 'true');
        }
      }, this);
    }

    _toggleSubmit(ready) {
      var form = this._form();
      if (!form) {
        return;
      }
      var button = form.querySelector('[type="submit"]');
      if (!button) {
        return;
      }
      if (!this._buttonLabel) {
        this._buttonLabel = button.querySelector('span') ? button.querySelector('span').textContent : button.textContent;
      }
      button.disabled = !ready;
      var span = button.querySelector('span') || button;
      span.textContent = ready ? this._buttonLabel : this.data.strings.unavailable;
    }

    _handleSubmit(event) {
      var form = event.target;
      if (!form || !form.getAttribute || form.getAttribute('id') !== this.formId) {
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      this._addToCart();
    }

    async _addToCart() {
      var sizeTitle = this._sizeTitle();
      var lines = this._linesFor(sizeTitle);
      if (lines.some(function (v) { return !v || !v.available; })) {
        return;
      }

      var form = this._form();
      var button = form ? form.querySelector('[type="submit"]') : null;
      this.errorEl.hidden = true;
      if (button) {
        button.setAttribute('aria-busy', 'true');
        button.disabled = true;
      }

      var bundleId = this.data.group + '-' + Math.random().toString(36).slice(2, 10);
      var properties = {
        _BundleId: bundleId,
        _BundleParentVariantId: String(this.shellVariantId),
        _BundleTitle: this.data.packTitle
      };

      var sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } })
      );

      var payload = {
        items: lines.map(function (v) {
          return { id: v.id, quantity: 1, properties: properties };
        }),
        sections: sections.join(','),
        sections_url: window.location.pathname
      };

      try {
        var response = await fetch(Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(payload)
        });

        var responseJson = await response.json();

        if (!response.ok) {
          this.errorEl.textContent = responseJson.description || this.dataset.errorMessage || 'Error';
          this.errorEl.hidden = false;
          return;
        }

        var cart = await (await fetch(Shopify.routes.root + 'cart.js')).json();
        cart.sections = responseJson.sections;

        document.dispatchEvent(
          new CustomEvent('variant:add', {
            detail: {
              items: responseJson.items || [responseJson],
              cart: cart
            }
          })
        );
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'variant:add',
              cart: cart
            }
          })
        );
      } catch (e) {
        this.errorEl.textContent = this.dataset.errorMessage || 'Error';
        this.errorEl.hidden = false;
      } finally {
        if (button) {
          button.removeAttribute('aria-busy');
        }
        this._update();
      }
    }
  }

  window.customElements.define('pack-set', PackSet);
})();
